export default {
  props: {
    isSuccess: Boolean,
    isWarnning: Boolean,
    content: String
  }
};
